export default __webpack_public_path__ + "static/media/Punto_06_Chiesa_e_Convento_dei_Domenicani_ENG_Def.957b77cf.aac";